import {LitElement, css, html} from 'lit';
import {customElement, state} from 'lit/decorators.js';
import {repeat} from 'lit/directives/repeat.js';
import {animate, fadeIn} from '@lit-labs/motion';
import {ContextConsumer} from '@lit/context';
import {artistContext } from '../context/artist-context.ts';
import { ref, Ref, createRef } from 'lit/directives/ref.js';

@customElement('artist-filter')
export class ArtistFilter extends LitElement {

  @state()
  private filters?: any = []
  private filterSets?: any = []

  dropdownRef: Ref<any> = createRef();

  private transformFilters(data:any) {
    let filters:any = []
    const filterCollections = data.filterCollections
    filterCollections?.map((filterCollection:any) => {
      filterCollection.filterGroups?.map((filterGroup:any) => {
        filterGroup.filterSets?.map((filterSet:any) => {
          filters = filterSet.filter
        })
      })
    })
    return filters
  }
  private transformFilterSets(data:any) {
    let filterSets:any = []
    const filterCollections = data.filterCollections
    filterCollections?.map((filterCollection:any) => {
      filterCollection.filterGroups?.map((filterGroup:any) => {
        filterSets = filterGroup.filterSets
      })
    })
    return filterSets
  }

  private _onChange(filter: any) {
    const options = {
      detail: filter.apiLink,
      bubbles: true,
      composed: true
    };
    this.dispatchEvent(new CustomEvent('artistFilterChange', options));
  }

  connectedCallback() {
    super.connectedCallback()
    new ContextConsumer(this, {
      context: artistContext,
      subscribe: true,
      callback: ({data}) => {
        if (data) {
          this.filters = this.transformFilters(data)
          this.filterSets = this.transformFilterSets(data)
          this.requestUpdate();
        }
      },
    });
  }
  createRenderRoot() {
    return this;
  }
  render() {
    return html`
        ${repeat(this.filterSets, (filterSet:any) => filterSet.identifier, (filterSet) => html`
            <z3-dropdown closeonclickinside ${ref(this.dropdownRef)} label="${filterSet.label}" autowidth="false" class="filterset-${filterSet.identifier}">
                ${repeat(filterSet.filter, (filter:any) => filter.identifier, (filter, i) => html`
                    <div class="filter ${filter.enabled ? '' : 'disabled'}" ${animate({
                        keyframeOptions: {
                          duration: 500,
                          delay: (i * 500) / this.filters.length,
                            fill: 'both',
                        },
                        properties: ['opacity'],
                        in: fadeIn
                    })}>
                        <label class="checkbox ${filter.enabled ? '' : 'disabled'}">
                            <input .type="${filter.type}"
                                   .checked="${filter.selected}"
                                   .disabled="${!filter.enabled}"
                                   @change="${() => this._onChange(filter)}">
                            <span>${filter.label}</span>
                        </label>
                    </div>
                `)}
            </z3-dropdown>
        `)}
    `}

  static styles = css`
      :host {
      }
      z3-dropdown {
      }
      z3-dropdown::part(button) {
          color: white;
          padding: 1rem 2rem;
          border-radius: 9999px;
          border: 1px solid white;
      }
      
      z3-dropdown::part(dropdown) {
          background: rgb(30,30,30);
          padding: 2rem;
          border-radius: 1.25rem;
      }
      
      .filter + .filter {
          margin-top: 1rem;
      }
      
      .checkbox {
          display: flex;
          position: relative;
          cursor: pointer;
          padding-left: 2rem;
      }
      .checkbox [type=checkbox] {
          position: absolute;
          left: 0;
          opacity: 0;
          pointer-events: none;
          padding: 0;
      }
      .checkbox [type=checkbox]+span {
          font-size: 1.25rem;
          text-transform: uppercase;
          margin-top: -2px;
      }
      .checkbox [type=checkbox]+span:before {
          content: "";
          position: absolute;
          top: 1px;
          left: 0;
          width: 20px;
          height: 20px;
          z-index: 0;
          border: 1px solid;
          border-radius: 2px;
          box-shadow: none;
      }
      .checkbox [type=checkbox]+span:after {
          content: "";
          position: absolute;
          top: -3px;
          left: 4px;
          opacity: 0;
          width: 1.5rem;
          height: 1.5rem;
          background-image: url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' width='58.594' height='44.688'%3E%3Cpath d='M18.594 35.313 53.906 0l4.688 4.688-40 40L0 26.093l4.688-4.688Zm50 19.453' style='fill:%2335CC9A'/%3E%3C/svg%3E");
          background-size: contain;
          background-position: 50%;
          background-repeat: no-repeat;
          --tw-text-opacity: 1;
          color: #35CC9A;
      }
      .checkbox [type=checkbox]:checked+span:after {
          opacity: 1;
      }
      
      /* disabled Checkbox */
      .checkbox.disabled {
          cursor: not-allowed;
          opacity: 0.4;
      }
  `;
}

declare global {
  interface HTMLElementTagNameMap {
    'artist-filter': ArtistFilter
  }
}
